import {
	createRouter,
	createWebHistory
} from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import Home from '../views/Home.vue'

const routes = [{
		path: '/',
		redirect: 'Home'
		// component: HomeView
	},
	{
		path: '/home',
		name: 'Home',
		component: Home,
		meta: {
			title: "雨诺股份，重构医药大健康数字化能力"
		},
	},
	{
		path: '/enterpriseSolution',
		name: 'EnterpriseSolution',
		meta: {
			title: "集团企业解决方案"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/EnterpriseSolution.vue')
	},
	{
		path: '/groupSolution',
		name: 'GroupSolution',
		meta: {
			title: "医药新零售解决方案"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/GroupSolution.vue')
	},
	{
		path: '/smallSolution',
		name: 'SmallSolution',
		meta: {
			title: "小微企业解决方案"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/SmallSolution.vue')
	},
	{
		path: '/mediumSolotion',
		name: 'MediumSolotion',
		meta: {
			title: "中大型企业解决方案"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/MediumSolotion.vue')
	},
	{
		path: '/productCenterOms',
		name: 'ProductCenterOms',
		meta: {
			title: "OMS订单中台"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterOms.vue')
	},
	{
		path: '/productCenterHospital',
		name: 'ProductCenterHospital',
		meta: {
			title: "医馆云"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterHospital.vue')
	},
	{
		path: '/productCenterInsurancel',
		name: 'ProductCenterInsurancel',
		meta: {
			title: "医保云"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterInsurancel.vue')
	},
	{
		path: '/productCenterMicroenterprise',
		name: 'ProductCenterMicroenterprise',
		meta: {
			title: "小微供应链云"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterMicroenterprise.vue')
	},
	{
		path: '/productCenterGroup',
		name: 'ProductCenterGroup',
		meta: {
			title: "集团供应链云"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterGroup.vue')
	},
	{
		path: '/productCenterChain',
		name: 'ProductCenterChain',
		meta: {
			title: "连锁供应链云"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterChain.vue')
	},
	{
		path: '/productCenterWms',
		name: 'ProductCenterWms',
		meta: {
			title: "WMS"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterWms.vue')
	},
	{
		path: '/productCenterDtp',
		name: 'ProductCenterDtp',
		meta: {
			title: "DTP管理"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterDtp.vue')
	},
	{
		path: '/productCenterCrm',
		name: 'ProductCenterCrm',
		meta: {
			title: "会员CRM云"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterCrm.vue')
	},
	{
		path: '/productCenterStore',
		name: 'ProductCenterStore',
		meta: {
			title: "门店云"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterStore.vue')
	},
	{
		path: '/productCenterNcd',
		name: 'ProductCenterNcd',
		meta: {
			title: "慢病管理"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterNcd.vue')
	},
	{
		path: '/productCenterPrescription',
		name: 'ProductCenterPrescription',
		meta: {
			title: "处方平台"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterPrescription.vue')
	},
	{
		path: '/productCenterPrivate',
		name: 'ProductCenterPrivate',
		meta: {
			title: "私域商城"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ProductCenterPrivate.vue')
	},
	{
		path: '/ecologicalCooperation',
		name: 'EcologicalCooperation',
		meta: {
			title: "生态合作"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/EcologicalCooperation.vue')
	},
	{
		path: '/newsCenter',
		name: 'NewsCenter',
		meta: {
			title: "新闻中心"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsCenter.vue')
	},
	{
		path: '/newsInfor1',
		name: 'NewsInfor1',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor1.vue')
	},
	{
		path: '/newsInfor2',
		name: 'NewsInfor2',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor2.vue')
	},
	{
		path: '/newsInfor3',
		name: 'NewsInfor3',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor3.vue')
	},
	{
		path: '/newsInfor4',
		name: 'NewsInfor4',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor4.vue')
	},
	{
		path: '/newsInfor5',
		name: 'NewsInfor5',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor5.vue')
	},
	{
		path: '/newsInfor6',
		name: 'NewsInfor6',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor6.vue')
	},
	{
		path: '/newsInfor7',
		name: 'NewsInfor7',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor7.vue')
	},
	{
		path: '/newsInfor8',
		name: 'NewsInfor8',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor8.vue')
	},
	{
		path: '/newsInfor9',
		name: 'NewsInfor9',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor9.vue')
	},
	{
		path: '/newsInfor10',
		name: 'NewsInfor10',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor10.vue')
	},
	{
		path: '/newsInfor11',
		name: 'NewsInfor11',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor11.vue')
	},
	{
		path: '/newsInfor12',
		name: 'NewsInfor12',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor12.vue')
	},
	{
		path: '/newsInfor13',
		name: 'NewsInfor13',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor13.vue')
	},
	{
		path: '/newsInfor14',
		name: 'NewsInfor14',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor14.vue')
	},
	{
		path: '/newsInfor15',
		name: 'NewsInfor15',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor15.vue')
	},
	{
		path: '/newsInfor16',
		name: 'NewsInfor16',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor16.vue')
	},
	{
		path: '/newsInfor17',
		name: 'NewsInfor17',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor17.vue')
	},
	{
		path: '/newsInfor18',
		name: 'NewsInfor18',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor18.vue')
	},
	{
		path: '/newsInfor19',
		name: 'NewsInfor19',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor19.vue')
	},
	{
		path: '/newsInfor20',
		name: 'NewsInfor20',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor20.vue')
	},
	{
		path: '/newsInfor21',
		name: 'NewsInfor21',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor21.vue')
	},
	{
		path: '/newsInfor22',
		name: 'NewsInfor22',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor22.vue')
	},
	{
		path: '/newsInfor23',
		name: 'NewsInfor23',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor23.vue')
	},
	{
		path: '/newsInfor24',
		name: 'NewsInfor24',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor24.vue')
	},
	{
		path: '/newsInfor25',
		name: 'NewsInfor25',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor25.vue')
	},
	{
		path: '/newsInfor26',
		name: 'NewsInfor26',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor26.vue')
	},
	{
		path: '/newsInfor27',
		name: 'NewsInfor27',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor27.vue')
	},
	{
		path: '/newsInfor28',
		name: 'NewsInfor28',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor28.vue')
	},
	{
		path: '/newsInfor29',
		name: 'NewsInfor29',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor29.vue')
	},
	{
		path: '/newsInfor30',
		name: 'NewsInfor30',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor30.vue')
	},
	{
		path: '/newsInfor31',
		name: 'NewsInfor31',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor31.vue')
	},
	{
		path: '/newsInfor32',
		name: 'NewsInfor32',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor32.vue')
	},
	{
		path: '/newsInfor33',
		name: 'NewsInfor33',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor33.vue')
	},
	{
		path: '/newsInfor34',
		name: 'NewsInfor34',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor34.vue')
	},
	{
		path: '/newsInfor35',
		name: 'NewsInfor35',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor35.vue')
	},
	{
		path: '/newsInfor36',
		name: 'NewsInfor36',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor36.vue')
	},
	{
		path: '/newsInfor37',
		name: 'NewsInfor37',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor37.vue')
	},
	{
		path: '/newsInfor38',
		name: 'NewsInfor38',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor38.vue')
	},
	{
		path: '/newsInfor39',
		name: 'NewsInfor39',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor39.vue')
	},
	{
		path: '/newsInfor40',
		name: 'NewsInfor40',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor40.vue')
	},
	{
		path: '/newsInfor41',
		name: 'NewsInfor41',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor41.vue')
	},
	{
		path: '/newsInfor42',
		name: 'NewsInfor42',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor42.vue')
	},
	{
		path: '/newsInfor43',
		name: 'NewsInfor43',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor43.vue')
	},
	{
		path: '/newsInfor44',
		name: 'NewsInfor44',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor44.vue')
	},
	{
		path: '/newsInfor45',
		name: 'NewsInfor45',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor45.vue')
	},
	{
		path: '/newsInfor46',
		name: 'NewsInfor46',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor46.vue')
	},
	{
		path: '/newsInfor47',
		name: 'NewsInfor47',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor47.vue')
	},
	{
		path: '/newsInfor48',
		name: 'NewsInfor48',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor48.vue')
	},
	{
		path: '/newsInfor49',
		name: 'NewsInfor49',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor49.vue')
	},
	{
		path: '/newsInfor50',
		name: 'NewsInfor50',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor50.vue')
	},
	{
		path: '/newsInfor51',
		name: 'NewsInfor51',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor51.vue')
	},
	{
		path: '/newsInfor52',
		name: 'NewsInfor52',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor52.vue')
	},
	{
		path: '/newsInfor53',
		name: 'NewsInfor53',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor53.vue')
	},
	{
		path: '/newsInfor54',
		name: 'NewsInfor54',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor54.vue')
	},
	{
		path: '/newsInfor55',
		name: 'NewsInfor55',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor55.vue')
	},
	{
		path: '/newsInfor56',
		name: 'NewsInfor56',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor56.vue')
	},
	{
		path: '/newsInfor57',
		name: 'NewsInfor57',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor57.vue')
	},
	{
		path: '/newsInfor58',
		name: 'NewsInfor58',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor58.vue')
	},
	{
		path: '/newsInfor59',
		name: 'NewsInfor59',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor59.vue')
	},
	{
		path: '/newsInfor60',
		name: 'NewsInfor60',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor60.vue')
	},
	{
		path: '/newsInfor61',
		name: 'NewsInfor61',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor61.vue')
	},
	{
		path: '/newsInfor62',
		name: 'NewsInfor62',
		meta: {
			title: "益丰大药房携手雨诺搭建药品追溯码上报平台",
			description: "1月2日，国家医保局发布公告强调，自2025年1月1日起全面推进“码上”严监管措施。益丰大药房积极响应号召，携手雨诺股份搭建药品追溯码上报平台，已在多省成功上线、稳步铺开，为守护居民用药安全和医保基金安全做出贡献。",
			keywords: "药品追溯码，益丰大药房，医保基金，医保监管，追溯码上报，益丰大药房携手雨诺搭建药品追溯码上报平台，益丰大药房搭建药品追溯码上报平台，益丰大药房追溯码平台",
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor62.vue')
	},
	{
		path: '/newsInfor63',
		name: 'NewsInfor63',
		meta: {
			title: "上药控股携手雨诺打造全国新零售信息一体化标杆",
			description: "近日，上药控股与雨诺股份合作启动了全国新零售信息一体化项目。该项目旨在通过升级改造技术平台、整合零售业务、建设专业药房以及赋能AI等方面，提升上药控股在零售业务领域的竞争力和服务质量。",
			keywords: "AI智能，上药控股，华氏，益药，新零售，上药控股打造全国新零售信息一体化标杆，华氏大药房数字化，上药控股携手雨诺打造全国新零售信息一体化标杆",
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor63.vue')
	},
	{
		path: '/newsInfor64',
		name: 'NewsInfor64',
		meta: {
			title: "国药控股国大药房携手雨诺打造会员管理和会员数据平台",
			description: "6月23日，国药控股国大药房会员管理和会员数据平台项目启动会在上海国药控股大厦隆重召开。雨诺将基于云原生平台，为国药控股国大药房构建一个集团一体化的会员管理与数据平台，助力国大药房数智化转型升级。",
			keywords: "国药控股国大药房，云原生平台，集团一体化，会员管理，会员数据，国大药房数字化转型，国大药房打造会员管理和会员数据平台，国药控股国大药房携手雨诺打造会员管理和会员数据平台",
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor64.vue')
	},
	{
		path: '/newsInfor65',
		name: 'NewsInfor65',
		meta: {
			title: "新闻详情",
			description: "9月16日，哈药集团人民同泰携手雨诺及金蝶的业财一体化项目启动会议在人民同泰总部顺利举行。此次合作旨在共同构建一个涵盖多组织、多业态、集团化的业财一体化管理平台，实现集团内部组织交易、多组织业务流程与财务管理的深度整合，助力企业在激烈的市场竞争中稳健前行。",
			keywords: "哈药集团人民同泰，业财一体化,集团化管理，信创国产化替代，云原生平台，哈药集团打造业财一体化管理平台，哈药集团人民同泰携手雨诺开启业财一体化新篇章",
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor65.vue')
	},
	{
		path: '/newsInfor66',
		name: 'NewsInfor66',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor66.vue')
	},
	{
		path: '/newsInfor67',
		name: 'NewsInfor67',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor67.vue')
	},
	{
		path: '/newsInfor68',
		name: 'NewsInfor68',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor68.vue')
	},
	{
		path: '/newsInfor69',
		name: 'NewsInfor69',
		meta: {
			title: "新闻详情",
			description: "6月3日，仁和堂非商核算项目启动会在仁和堂总部圆满召开。雨诺将采用供应链云-供应商管理帮助仁和堂提高结算透明度，提升结算效率，最终打造一个数智化的全流程供应商管理闭环，进而提高整个供应链的协同效率和响应速度。",
			keywords: "仁和堂医药集团，翔宇集团，供应链协同，供应商管理，仁和堂打造数智化全流程供应商管理闭环，仁和堂携手雨诺打造数智化全流程供应商管理闭环",
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor69.vue')
	},
	{
		path: '/newsInfor70',
		name: 'NewsInfor70',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor70.vue')
	},
	{
		path: '/newsInfor71',
		name: 'NewsInfor71',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor71.vue')
	},
	{
		path: '/newsInfor72',
		name: 'NewsInfor72',
		meta: {
			title: "药品追溯码新规落地 快收好这份解决方案",
			description: "近期，雨诺推出了药品追溯码解决方案，为医药企业提供了应对药品追溯码新规的强大工具。该方案整合了药品追溯码、商品码等多种码信息，并同步至库存系统，实现了从扫码、验码到上报的全链条闭环管理。",
			keywords: "药品追溯码，进销存数据，追溯码上传，库存管理，追溯码解决方案，追溯码怎么实现",
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor72.vue')
	},
	{
		path: '/newsInfor73',
		name: 'NewsInfor73',
		meta: {
			title: "津药达仁堂集团与雨诺达成战略合作",
			description: "近期，津药达仁堂集团与雨诺达成战略合作，双方携手开启数字化新征程。此次合作依托雨诺新一代集团企业平台，旨在筑牢根基，全面提升津药达仁堂集团的新零售数字化能力，并引入智能应用，打造中医药行业数字化升级新标杆。",
			keywords: "津药达仁堂集团，新零售数字化能力，智能应用，中医药企业数字化转型，津药达仁堂集团与雨诺达成战略合作，津药达仁堂集团数字化升级",
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor73.vue')
	},
	{
		path: '/newsInfor74',
		name: 'NewsInfor74',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor74.vue')
	},
	{
		path: '/newsInfor75',
		name: 'NewsInfor75',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor75.vue')
	},
	{
		path: '/newsInfor76',
		name: 'NewsInfor76',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor76.vue')
	},
	{
		path: '/newsInfor77',
		name: 'NewsInfor77',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor77.vue')
	},
	{
		path: '/newsInfor78',
		name: 'NewsInfor78',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor78.vue')
	},
	{
		path: '/newsInfor79',
		name: 'NewsInfor79',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor79.vue')
	},
	{
		path: '/newsInfor80',
		name: 'NewsInfor80',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor80.vue')
	},
	{
		path: '/newsInfor81',
		name: 'NewsInfor81',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor81.vue')
	},
	{
		path: '/newsInfor82',
		name: 'NewsInfor82',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor82.vue')
	},
	{
		path: '/newsInfor83',
		name: 'NewsInfor83',
		meta: {
			title: "新闻详情"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/NewsInfor83.vue')
	},
	{
		path: '/aboutUs',
		name: 'AboutUs',
		meta: {
			title: "公司简介"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/AboutUs.vue')
	},
	{
		path: '/contactUs',
		name: 'ContactUs',
		meta: {
			title: "联系我们"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/ContactUs.vue')
	},
	{
		path: '/talentRecruitment',
		name: 'TalentRecruitment',
		meta: {
			title: "人才招聘"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/TalentRecruitment.vue')
	},
	{
		path: '/socialResponsibility',
		name: 'SocialResponsibility',
		meta: {
			title: "社会责任"
		},
		component: () => import( /* webpackChunkName: "about" */ '../views/SocialResponsibility.vue')
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	// history: createWebHashHistory(process.env.BASE_URL),
	routes
})
router.beforeEach((to, from, next) => {
	if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
	  window.location.href = 'http://m.romens.cn'
	  return
	}
	next()
})


export default router
